import { render, staticRenderFns } from "./taxesIndex.vue?vue&type=template&id=3b965e7d&"
import script from "./taxesIndex.vue?vue&type=script&lang=js&"
export * from "./taxesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports